import type { TaskPayReportItemType } from '@econtractor/types';
import { isTaskPayUsd } from 'modules/task';

const toMoney = (value: number): number => Math.round(value * 100) / 100;

export interface TaskPayTotals {
    amount: number;
    amountRate: number;
}

/** Базова і місцева сума задач виконавця за поточним курсом. */
export const sumTaskPay = (rows: TaskPayReportItemType[], rate: number): TaskPayTotals => {
    const safeRate = Number(rate) || 1;
    let base = 0;
    let local = 0;

    for (const row of rows) {
        if (!row.pay) continue;
        const amount = Number(row.payAmount) || 0;
        if (isTaskPayUsd(row.payUsd, safeRate)) {
            base += amount;
            local += amount * safeRate;
        } else {
            local += amount;
            base += safeRate === 1 ? amount : amount / safeRate;
        }
    }

    return { amount: toMoney(base), amountRate: toMoney(local) };
};
